export const MAPBOX_TOKEN = 'pk.eyJ1IjoiZ2VvbGxlY3RyeWFuIiwiYSI6ImNtNXppaGp2bzAyd3AybHIxcW05Z2t6bnYifQ.2ySFUnaQrTMmJ7FsavVhuw';
